export default __webpack_public_path__ + "static/media/chat_list.f374b90f.JPG";